import { render } from "./Pagination.vue?vue&type=template&id=36c3e810&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=36c3e810&lang=scss&scoped=true"

import exportComponent from "/Users/johnguanlao/Desktop/wrk/CodeTogether/RSJI-Equity-Actions/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c3e810"]])

export default __exports__